import React from "react";

import PropTypes from "prop-types";
import Spin from "shared/components/Spin";
import "./styles.scss";

const Button = ({
  loading,
  text,
  variant,
  onClick,
  disabled,
  fillWidth,
  custom,
}) => {
  const VARIANT_STYLE = {
    SECONDARY: "button-secondary",
    TERTIARY: "button-tertiary",
    BORDERED: "button-primary--bordered",
    ERROR: "button-error",
    ERROR_OUTLINED: "button-error-outlined",
  };
  return (
    <div
      onClick={onClick}
      aria-disabled={loading || disabled}
      className={`button 
        ${!(disabled || loading) && VARIANT_STYLE[variant]} 
      ${(disabled || loading) && "button-disabled"}
      ${fillWidth && "full-width"} ${custom}`}>
      {loading ? <Spin /> : <p>{text}</p>}
    </div>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.string,
  custom: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  fillWidth: PropTypes.bool,
};

export default Button;
